export const GET_ALL_TEXT = "GET_ALL_TEXT";
export const GET_ALL_DEVICE = "GET_ALL_DEVICE";
export const GET_ALL_FORM = "GET_ALL_FORM";
export const GET_ALL_IMAGES = "GET_ALL_IMAGES";
export const GET_ALL_CARDS_FOR_TABLE = "GET_ALL_CARDS_FOR_TABLE";
export const GET_ALL_CARDS_STATUS = "GET_ALL_CARDS_STATUS";
export const GET_TOTAL_DEVICES = "GET_TOTAL_DEVICES";